"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CaptchaGeneratorV3_1 = require("./CaptchaGeneratorV3");
exports.default = CaptchaGeneratorV3_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CaptchaGeneratorV3/index.js
// module id = 1748
// module chunks = 8